import { isObject, isString, isArray } from 'utils/typeUtils';
import { isNumber } from '../utils/typeUtils';
import { OriginalMenu } from './menu';

/**
 * メニューカテゴリー
 */
export type MenuCategory = OriginalMenuCategory & {
  menus: OriginalMenu[];
};

/**
 * メニューカテゴリー from api
 */
export type OriginalMenuCategory = {
  id: number;
  name: string;
  displayOrder: number;
};

/**
 * OriginalMenuCategory から MenuCategory への変換
 */
export const mapOriginalMenuCategoryToMenuCategory = (
  menuCategory: OriginalMenuCategory,
): MenuCategory => ({
  ...menuCategory,
  menus: [],
});

/**
 * メニューカテゴリーの型ガード
 */
const isOriginalMenuCategory = (arg: unknown): arg is MenuCategory => {
  const a = arg as MenuCategory;

  return (
    isObject(a) &&
    isNumber(a.id) &&
    isString(a.name) &&
    isNumber(a.displayOrder)
  );
};

/**
 * メニューカテゴリーの配列の型ガード
 */
export const isOriginalMenuCategories = (
  arg: unknown,
): arg is OriginalMenuCategory[] => {
  const a = arg as OriginalMenuCategory[];

  return (
    isObject(a) && isArray<OriginalMenuCategory>(a, isOriginalMenuCategory)
  );
};
